import { BlockOutlined, LockOpenOutlined } from '@mui/icons-material';
import { SvgIconOwnProps } from '@mui/material/SvgIcon';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type BlockUnblockIconProps = {
  blocked: boolean;
} & SvgIconOwnProps;

const BlockUnblockIcon = ({ blocked, ...rest }: BlockUnblockIconProps) => {
  if (blocked) return <LockOpenOutlined {...rest} />;
  return <BlockOutlined {...rest} />;
};

export default BlockUnblockIcon;

export const useGetBlockUnblockIconLabel = () => {
  const { t } = useTranslation();

  const getLabel = useCallback(
    (blocked: boolean) => {
      if (blocked) return t('page.customers.card.unblockUser');
      return t('page.customers.card.blockUser');
    },
    [t],
  );

  return { getLabel };
};
